
// frontend/src/components/Sports/IPTVFunnel.js
// REDESIGNED: Premium CTA with Glass Morphism
import React from 'react';
import { motion } from 'framer-motion';
import { Tv, CheckCircle, Smartphone, Zap, ExternalLink } from 'lucide-react';

export const IPTVFunnel = ({ sportName }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="relative overflow-hidden rounded-3xl"
        >
            {/* Animated Gradient Border */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary via-purple-500 to-blue-600 opacity-50 blur-xl" />

            <div
                className="relative rounded-3xl p-1 bg-gradient-to-r from-primary via-purple-500 to-blue-600"
            >
                <div
                    className="rounded-[22px] p-6 md:p-10"
                    style={{
                        background: 'rgba(0, 0, 0, 0.85)',
                        backdropFilter: 'blur(20px)',
                    }}
                >
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-8">

                        {/* Left Content */}
                        <div className="flex-1 space-y-5">
                            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/20 border border-primary/30 rounded-full">
                                <Zap className="w-4 h-4 text-primary" />
                                <span className="text-xs font-bold text-primary uppercase tracking-wider">Premium Streaming</span>
                            </div>

                            <h3 className="text-3xl md:text-4xl font-black tracking-tight text-white">
                                Watch Every <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400">{sportName}</span> Match Live
                            </h3>

                            <p className="text-lg text-muted-foreground leading-relaxed">
                                Stop chasing blurry streams. Get <span className="text-white font-bold">4K/60FPS</span> coverage of every game, no blackouts, no buffering.
                            </p>

                            <div className="flex flex-wrap gap-6 pt-2">
                                <div className="flex items-center gap-2 text-sm font-medium text-white">
                                    <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center">
                                        <CheckCircle className="w-4 h-4 text-green-400" />
                                    </div>
                                    <span>Zero Buffering</span>
                                </div>
                                <div className="flex items-center gap-2 text-sm font-medium text-white">
                                    <div className="w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center">
                                        <CheckCircle className="w-4 h-4 text-green-400" />
                                    </div>
                                    <span>All Regions</span>
                                </div>
                                <div className="flex items-center gap-2 text-sm font-medium text-white">
                                    <div className="w-6 h-6 rounded-full bg-blue-500/20 flex items-center justify-center">
                                        <Smartphone className="w-4 h-4 text-blue-400" />
                                    </div>
                                    <span>All Devices</span>
                                </div>
                            </div>
                        </div>

                        {/* Right CTA */}
                        <div className="flex flex-col gap-4 w-full lg:w-auto lg:min-w-[280px]">
                            <motion.a
                                href="/guides/pricing"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.98 }}
                                className="group relative overflow-hidden bg-gradient-to-r from-primary to-blue-500 text-white px-8 py-5 rounded-2xl font-bold text-center text-lg shadow-2xl shadow-primary/30 transition-all flex items-center justify-center gap-2"
                            >
                                <Tv className="w-5 h-5" />
                                <span>Get Free Trial</span>
                                <ExternalLink className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />

                                {/* Shine Effect */}
                                <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent" />
                            </motion.a>

                            <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground">
                                <span className="flex items-center gap-1">
                                    <Tv className="w-3 h-3" /> Firestick
                                </span>
                                <span>•</span>
                                <span>Roku</span>
                                <span>•</span>
                                <span>Apple TV</span>
                                <span>•</span>
                                <span>Android</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </motion.div>
    );
};
